
import request from '@/common/js/request'
import $config from '@/config'
/**
 * 获取列表数据
 */
export const userLogin = (data) => {
    return request('/auth/login',{
        // headers: {
        //     'Authorization': `Basic ${$config.basic}`
        // },
        data,
        method: 'post'
    })
}

/**
 * 获取公钥数据
 */
export const getRsaPublicKey = (params) => {
    return request('/auth/rsaPublicKey',{
        params: params,
        method: 'get'
    })
}

/**
 * 获取登录验证码
 */
export const getLoginCode = (data) => {
    return request('/vcc/code',{
        params: data,
        method: 'get'
    })
}

/**
 * 获取验证码状态
 */
export const getIsLoginCodeStatus = (params) => {
    return request('/vcc/verify',{
        data: params,
        method: 'post'
    })
}


/**
 * 获取用户信息
 */
export const getUserInfo = (params) => {
    return request('/user/currentUser', {
        params: params,
        method: 'get'
    })
}


/**
 * 获取用户详情信息
 */
export const getUserDetailInfo = (params) => {
    return request('/user/currentUser', {
        params: params,
        method: 'get'
    })
}

/***
 * 获取用户数据列表
 */
export const getListPage = (params) => {
    return request('/baseUser/listPage', {
        params: params,
        method: 'get'
    })
}
/***
 * 获取用户数据列表无分页
 */
export const getList = (params) => {
    return request('/baseUser/list', {
        params: params,
        method: 'get'
    })
}
/***
 * 用户新增
 */
export const save = (params) => {
    return request('/baseUser/save',{
        data: params,
        method: 'post'
    })
}
/***
 * 修改密码
 */
export const updatePassword = (params) => {
    return request('/baseUser/updatePassword',{
        data: params,
        method: 'post'
    })
}
/**
 * 用户删除
 */
export const eliminate = (id) => {
    return request(`/baseUser/${id}`,{
        method: 'DELETE'
    })
}
/***
 * 获取组织树数据
 */
export const getDeptList = (params) => {
    return request('/baseDept/list', {
        params: params,
        method: 'get'
    })
}

/**
 * 用户退出登录
 */
export const singOut = (params) => {
    return request('/user/loginOut', {
        params: params,
        method: 'get'
    })
}

/***
 * 更新用户信息
 */
export const updateUserInfo = (params) => {
    return request('/baseUser/updateUserInfo',{
        data: params,
        method: 'post'
    })
}
